const paymentMethodsIT = {
    "view": {
        "table": {
            "title": "La tua lista di metodi di pagamento",
            "column": {
                "cardholder_name": "Nome del Titolare",
                "card_number": "Numero della Carta",
                "expiry_month": "Mese di Scadenza",
                "expiry_year": "Anno di Scadenza",
                "type": "Tipo",
                "status": "Stato",
                "action": "Azione"
            },
            "label": {
                "is_default": "Predefinito",
                "is_secondary": "Secondario",
                "is_valid": "Valido",
                "is_expired": "Scaduto",
                "not_available": "Non Disponibile",
                "month_january": "Gennaio",
                "month_february": "Febbraio",
                "month_march": "Marzo",
                "month_april": "Aprile",
                "month_may": "Maggio",
                "month_june": "Giugno",
                "month_july": "Luglio",
                "month_august": "Agosto",
                "month_september": "Settembre",
                "month_october": "Ottobre",
                "month_november": "Novembre",
                "month_december": "Dicembre"
            },
            "dropdown": {
                "action": "Azione",
                "edit": "Modifica",
                "delete": "Elimina"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Hai raggiunto il limite di 3 metodi di pagamento. Se vuoi aggiungere un nuovo pagamento, puoi farlo eliminando uno esistente.",
            "success": "Metodo di pagamento rimosso!",
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!"
        },
        "modal": {
            "delete": {
                "header": "Elimina Metodo di Pagamento {{cardNumber}}",
                "body": "Sei sicuro di voler eliminare questo metodo di pagamento?"
            }
        }
    },
    "add": {
        "title": "Aggiungi Metodo di Pagamento",
        "form": {
            "label": {
                "card_details": "Dettagli della Carta",
                "cardholder_name": "Nome del Titolare",
                "card_number": "Numero della Carta",
                "expiry_month": "Mese di Scadenza",
                "expiry_year": "Anno di Scadenza (YYYY)",
                "security_code_cvc": "Codice di Sicurezza (CVC)",
                "billing_details": "Dettagli di Fatturazione",
                "country": "Paese",
                "street_and_number": "Via e Numero Civico",
                "city": "Città",
                "postal_code": "Codice Postale"
            },
            "help_text": {
                "security_code_cvc": "Il codice di sicurezza della tua carta (CVC) è il numero di 3 o 4 cifre situato sul retro della maggior parte delle carte."
            },
            "options": {
                "month": {
                    "january": "Gennaio",
                    "february": "Febbraio",
                    "march": "Marzo",
                    "april": "Aprile",
                    "may": "Maggio",
                    "june": "Giugno",
                    "july": "Luglio",
                    "august": "Agosto",
                    "september": "Settembre",
                    "october": "Ottobre",
                    "november": "Novembre",
                    "december": "Dicembre"
                },
                "expiry_month": {
                    "select": "Seleziona Mese di Scadenza"
                },
                "country": {
                    "select": "Seleziona Paese"
                }
            },
            "button": {
                "submit": "Invia"
            },
            "validation": {
                "expiry_month_required": "Il Mese di Scadenza è obbligatorio",
                "expiry_month_valid": "Il Mese di Scadenza non deve essere nel passato",
                "country_required": "Il Paese è obbligatorio"
            }
        },
        "message": {
            "success": "Metodo di pagamento aggiunto!",
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Sei sicuro di voler aggiungere questo metodo di pagamento al tuo profilo?",
                "body": "Con la presente garantisci che tutti i dati forniti sono veritieri. Sei l'unico e legalmente responsabile per i dati forniti e per la veridicità di tali informazioni.",
                "button": {
                    "cancel": "Annulla",
                    "confirm": "Conferma"
                }
            }
        }
    },
    "update": {
        "title": "Aggiorna Metodo di Pagamento",
        "form": {
            "label": {
                "card_details": "Dettagli della Carta",
                "cardholder_name": "Nome del Titolare",
                "card_number": "Numero della Carta",
                "expiry_month": "Mese di Scadenza",
                "expiry_year": "Anno di Scadenza (YYYY)",
                "security_code_cvc": "Codice di Sicurezza (CVC)",
                "billing_details": "Dettagli di Fatturazione",
                "country": "Paese",
                "street_and_number": "Via e Numero Civico",
                "city": "Città",
                "postal_code": "Codice Postale",
                "set_as_default": "Imposta come Predefinito"
            },
            "help_text": {
                "security_code_cvc": "Il codice di sicurezza della tua carta (CVC) è il numero di 3 o 4 cifre situato sul retro della maggior parte delle carte."
            },
            "options": {
                "month": {
                    "january": "Gennaio",
                    "february": "Febbraio",
                    "march": "Marzo",
                    "april": "Aprile",
                    "may": "Maggio",
                    "june": "Giugno",
                    "july": "Luglio",
                    "august": "Agosto",
                    "september": "Settembre",
                    "october": "Ottobre",
                    "november": "Novembre",
                    "december": "Dicembre"
                },
                "expiry_month": {
                    "select": "Seleziona Mese di Scadenza"
                },
                "country": {
                    "select": "Seleziona Paese"
                }
            },
            "button": {
                "submit": "Invia"
            },
            "validation": {
                "expiry_month_required": "Il Mese di Scadenza è obbligatorio",
                "expiry_month_valid": "Il Mese di Scadenza non deve essere nel passato",
                "country_required": "Il Paese è obbligatorio"
            }
        },
        "message": {
            "success": "Metodo di pagamento aggiornato!",
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Sei sicuro di voler aggiornare il tuo metodo di pagamento?",
                "body": "Con la presente garantisci che tutti i dati forniti sono veritieri. Sei l'unico e legalmente responsabile per i dati forniti e per la veridicità di tali informazioni.",
                "button": {
                    "cancel": "Annulla",
                    "confirm": "Conferma"
                }
            }
        }
    }
};

export default paymentMethodsIT;